import { Buttons, CancelButton, Checkbox, DeleteButton, Level, ModalCard } from '~/components';
import { useApi, useIntegrations, useToast, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import React, { useState } from 'react';
import styled from 'styled-components';

const P = styled.p`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

function DeletePaymentDialog({ payment, onDelete, onClose }) {
  const { workspace } = useWorkspace();
  const integrations = useIntegrations();
  const [removeFromQuickBooks, setRemoveFromQuickBooks] = useState(false);
  const [removeFromXero, setRemoveFromXero] = useState(false);
  const [{ isSubmitting }, form] = useForm();
  const toast = useToast();
  const api = useApi();

  const handleSubmit = async () => {
    form.submit();

    if (removeFromQuickBooks) {
      try {
        await api.www.workspaces(workspace.id).clientPayments(payment.id).removeFromQuickBooks();
      } catch (error) {
        toast.error(error.message ?? 'An error has occurred. The payment has not been removed from QuickBooks.');
      }
    }

    if (removeFromXero) {
      try {
        await api.www.workspaces(workspace.id).clientPayments(payment.id).removeFromXero();
      } catch (error) {
        toast.error(error.message ?? 'An error has occurred. The payment has not been removed from Xero.');
      }
    }

    await api.www.workspaces(workspace.id).clientPayments(payment.id).delete();

    if (onDelete) await onDelete();
    form.done();
  };

  return (
    <ModalCard title="Delete Payment" onClose={onClose}>
      <ModalCard.Body>
        <P>Are you sure you want to delete this payment?</P>
      </ModalCard.Body>

      <ModalCard.Footer>
        <Level>
          {integrations.qbo && payment.qboPaymentId && (
            <Level.Item>
              <Checkbox
                label="Remove from QuickBooks"
                checked={removeFromQuickBooks}
                onChange={() => setRemoveFromQuickBooks(!removeFromQuickBooks)}
              />
            </Level.Item>
          )}

          {!!integrations.xero && payment.xeroPaymentId && (
            <Level.Item>
              <Checkbox
                label="Remove from Xero"
                subText={payment.xeroConnection?.name}
                checked={removeFromXero}
                onChange={() => setRemoveFromXero(!removeFromXero)}
              />
            </Level.Item>
          )}

          <Level.Item>
            <Buttons align="right">
              <CancelButton onClick={onClose}>Cancel</CancelButton>
              <DeleteButton isLoading={isSubmitting} onClick={handleSubmit}>
                Delete
              </DeleteButton>
            </Buttons>
          </Level.Item>
        </Level>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default DeletePaymentDialog;
